import styled from "styled-components";

const Label = styled.label`
  margin-top: 10px;
  margin-bottom: 10px;
  align-self: start;
`;
export default Label;